var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLineLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.403 104.1L27.545 255.956 179.403 407.9M506 255.957H50.837",
    strokeWidth: 43.09238
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiPg0KCTxnIHRyYW5zZm9ybT0ibWF0cml4KDAsMjEuNTQ2MTksLTIxLjU0NjE5LDAsNTA2LDEwNC4wOTkzNikiPg0KCQk8cGF0aCBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLXdpZHRoOjJweDtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kOyIgZD0iTSAwLDAgNy4wNDgsNy4wNDggMTQuMSwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLDE1LjE1OCkiIC8+DQoJCTxwYXRoIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOmN1cnJlbnRDb2xvcjtzdHJva2Utd2lkdGg6MnB4O3N0cm9rZS1saW5lY2FwOnNxdWFyZTtzdHJva2UtbGluZWpvaW46cm91bmQ7IiBkPSJNIDAsMCBWIDIxLjEyNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4wNDgpIiAvPg0KCTwvZz4NCjwvc3ZnPg0K";
export { SvgArrowLineLeft as ReactComponent };